module.exports = __webpack_public_path__ + "watermark3.d1485419.png";